// extracted by css-extract-rspack-plugin
export default {"container":"cD71lbTDy5QMj3hL"};